import Animations from '../animations';

export default class PopUp {
  static init() {
    const popup = document.querySelector('[data-module="pop-up"]');

    if (!popup) {
      return;
    }

    const closeButton = popup.querySelector('.pop-up__close');
    const dialog = popup.querySelector('.pop-up__dialog');
    const pageId = Array.from(document.body.classList).find((className) =>
      /^(?:page-id|postid)-\d+$/.test(className)
    );
    const storageKey = `flash-info-shown:${pageId || window.location.pathname}`;

    const openPopup = () => {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      Animations.popup(popup);
      dialog.focus();
    };

    const closePopup = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    const onEscape = (event) => {
      if (event.key === 'Escape') {
        closePopup();
      }
    };

    const onClickOutside = (event) => {
      if (event.target === popup || event.target === popup.querySelector('.pop-up__overlay')) {
        closePopup();
      }
    };

    window.addEventListener('load', () => {
      try {
        if (window.localStorage.getItem(storageKey)) {
          return;
        }
      } catch (error) {
        // Show the popup normally when localStorage is unavailable.
      }

      openPopup();

      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (error) {
        // Ignore storage errors so the popup remains functional.
      }
    });
    closeButton?.addEventListener('click', closePopup);
    document.addEventListener('keydown', onEscape);
    popup.addEventListener('click', onClickOutside);
  }
}
